<section>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="search_flex">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control misinput_control" placeholder="Search"
                            aria-label="Search" aria-describedby="button-addon2">
                        <div class="input-group-btn">
                            <button class="btn drop_iconsearch" type="submit">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div class="dropdown">
                        <button class="month_dropshow  dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <img src="../../../../assets/image/filter.png" alt="" class="asset_filter">
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right mis_select_show">
                            <li><a class="dropdown-item" >Approved</a></li>
                            <li><a class="dropdown-item" >Pending</a></li>
                            <li><a class="dropdown-item" >Rejected</a></li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="row">
            <div class="assettransfer_sec col-md-12">
                <div class="asset_transfer">
                    <div class="asset_title">
                        <h4>Art & Paintings - Capex</h4>
                    </div>
                    <div class="asset_right" (click)="pending()">
                        <i class="fa-solid fa-chevron-right"></i>
                    </div>
                    <div>
                        <ul class="asset_transferlist">
                            <li>
                                <h4 class="asset_date">69587458</h4>
                            </li>
                            <li>
                                <h4 class="asset_date">12-08-2024</h4>
                            </li>
                            <li>
                                <h4 class="pending_list" (click)="pending()">Pending</h4>
                            </li>
                        </ul>
                    </div>

                </div>

                <!-- static data -->

                <div class="asset_transfer">
                    <div class="asset_title">
                        <h4>Art & Paintings - Capex</h4>
                    </div>
                    <div class="asset_right">
                        <i class="fa-solid fa-chevron-right"></i>
                    </div>
                    <div>
                        <ul class="asset_transferlist">
                            <li>
                                <h4 class="asset_date">69587458</h4>
                            </li>
                            <li>
                                <h4 class="asset_date">12-08-2024</h4>
                            </li>
                            <li>
                                <h4 class="pending_list">Pending</h4>
                            </li>
                        </ul>
                    </div>

                </div>

                <!-- static data -->

                <div class="asset_transfer">
                    <div class="asset_title">
                        <h4>Art & Paintings - Capex</h4>
                    </div>
                    <div class="asset_right">
                        <i class="fa-solid fa-chevron-right"></i>
                    </div>
                    <div>
                        <ul class="asset_transferlist">
                            <li>
                                <h4 class="asset_date">69587458</h4>
                            </li>
                            <li>
                                <h4 class="asset_date">12-08-2024</h4>
                            </li>
                            <li>
                                <h4 class="pending_list">Pending</h4>
                            </li>
                        </ul>
                    </div>

                </div>

                <!-- static data -->

                <div class="asset_transfer">
                    <div class="asset_title">
                        <h4>Art & Paintings - Capex</h4>
                    </div>
                    <div class="asset_right" (click)="pending()">
                        <i class="fa-solid fa-chevron-right"></i>
                    </div>
                    <div>
                        <ul class="asset_transferlist">
                            <li>
                                <h4 class="asset_date">69587458</h4>
                            </li>
                            <li>
                                <h4 class="asset_date">12-08-2024</h4>
                            </li>
                            <li>
                                <h4 class="pending_list" (click)="pending()">Pending</h4>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>